import { render, staticRenderFns } from "./phoneTable.vue?vue&type=template&id=fb214b88&scoped=true"
import script from "./phoneTable.vue?vue&type=script&lang=ts"
export * from "./phoneTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb214b88",
  null
  
)

export default component.exports